import React from 'react';
import ReactHtmlParser from 'react-html-parser';

const InformacionAdicional = (props) => {
  const listaElementos = props.observaciones.filter((elemento) => elemento !== '');

  if (listaElementos.length === 0) return null;

  return (
    <div className='seccion'>
      <div className='info-extra'>
        {ReactHtmlParser(listaElementos)}
      </div>
    </div>
  );
};

export default InformacionAdicional;
